'use client';
import { createContext } from 'react';

const FieldsetContext = createContext(null);

export { FieldsetContext };
